import React, { createContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const FAQsContext = createContext();

const FAQsProvider = ({ children }) => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get('/api/faqs')
      .then((res) => {
        setFaqs(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <FAQsContext.Provider value={{ faqs, loading, error }}>
      {children}
    </FAQsContext.Provider>
  );
};

export { FAQsContext, FAQsProvider };
